import type { MouseEventHandler } from 'react';

import { Button } from 'components/Button/Button';
import { useI18n } from 'i18n/hooks/useI18n';

type Props = {
  ariaLabel?: string;
  onClear?: MouseEventHandler<HTMLButtonElement>;
  qaId?: string;
};

export function InputClearButtonSuffix({ ariaLabel, onClear, qaId }: Props) {
  const { i18n } = useI18n();

  return (
    <div style={{ display: 'inline-flex', paddingRight: 20 }}>
      <Button
        type="button"
        data-qa-id={qaId}
        variant="tertiary-grey"
        size="tiny"
        icon={{ name: 'close', type: 'normalized', size: 16 }}
        onClick={onClear}
        aria-label={ariaLabel ?? i18n('Clear input')}
        noPadding
      />
    </div>
  );
}
